import { HelpCircle } from "lucide-react";
import { useT } from "../../i18n";
import { Tooltip } from "./Tooltip";
import "./HelpHint.css";

interface HelpHintProps {
	title?: string;
	body: string;
	learnMoreHref?: string;
	learnMoreLabel?: string;
	ariaLabel?: string;
}

export function HelpHint({
	title,
	body,
	learnMoreHref,
	learnMoreLabel,
	ariaLabel,
}: HelpHintProps) {
	const t = useT();
	const linkLabel = learnMoreLabel ?? t.helpHint_learnMore;
	const buttonLabel =
		ariaLabel ??
		(title ? `${t.helpHint_ariaLabel}: ${title}` : t.helpHint_ariaLabel);

	return (
		<Tooltip
			content={
				<>
					{title && <p className="ui-tooltip__title">{title}</p>}
					<p className="ui-tooltip__body">{body}</p>
					{learnMoreHref && (
						<a
							className="ui-tooltip__learn-more"
							href={learnMoreHref}
							target="_blank"
							rel="noopener noreferrer"
						>
							{linkLabel} ↗
						</a>
					)}
				</>
			}
		>
			<button type="button" className="ui-help-hint" aria-label={buttonLabel}>
				<HelpCircle size={14} aria-hidden="true" />
			</button>
		</Tooltip>
	);
}
